export default __webpack_public_path__ + "static/media/VR.08d78974.svg";